var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRania(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245.14 253.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{isolation:isolate;font-family:YoungSerif-Regular, YoungSerif;}.cls-1{font-size:142.42px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9{fill:none;stroke:#000;stroke-miterlimit:24;stroke-width:0.5px;}.cls-2{font-size:41.35px;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{font-size:30.63px;}.cls-4{letter-spacing:-0.05em;}.cls-5,.cls-7{letter-spacing:-0.01em;}.cls-6{letter-spacing:-0.03em;}.cls-8{letter-spacing:-0.02em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(65.74 125.06)"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.23 159.86)"
  }, "ANIA"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(3.95 200.46)"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(27.16 200.46)"
  }, "o"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(44.44 200.46)"
  }, "n"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(63.52 200.46)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(76.41 200.46)"
  }, "r"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(92.19 200.46)"
  }, "o"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(109 200.46)"
  }, "l "), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(127.29 200.46)"
  }, "S", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 21.07,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(165.9 200.46)"
  }, "s"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(181.68 200.46)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(193.99 200.46)"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(209.61 200.46)"
  }, "m"), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.26,145.59a80.44,80.44,0,0,1-21.88-35.42C20.56,104,14.43,79.72,25.54,57.6c3.35-6.6,9.91-11,11.25-20.72.91-6.71-.67-12.78-1.48-15.85A53.1,53.1,0,0,0,27.65,4.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.26,27.64A42.52,42.52,0,0,0,7.92,44.3,42.12,42.12,0,0,0,25.49,57.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.13,91.69c3,3.21,13.06,13.36,28.53,14.46a39.48,39.48,0,0,0,13.54-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.46,14.19A24.34,24.34,0,0,1,53,25.67C47.7,34.29,38.66,36.54,36.74,37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.69,24.33c-3.4,3.55-3.16,8.91-3,11.06A20.18,20.18,0,0,0,6.73,41a16.41,16.41,0,0,0,5-3.68c.24-.29,4.46-5.17,3.69-11.4-.14-1.29-.38-3.2-1.67-3.78C11.75,21.22,8.88,24.14,8.69,24.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6.68,41a44.44,44.44,0,0,1,3-11.34,43.75,43.75,0,0,1,4-7.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.55,61.29c1.2-4.79,5.84-7.37,7.76-8.42a23.62,23.62,0,0,1,5.26-2.11,15.7,15.7,0,0,1-.48,6.17c-.09.34-2,6.52-7.66,9.2-1.19.57-2.92,1.38-4.11.62C-.45,65.6.5,61.63.55,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.57,50.76A43.52,43.52,0,0,0,1.32,66.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.87,85.8c-2.68,4.12-1.39,9.34-.91,11.44a21.25,21.25,0,0,0,2.11,5.32A15.38,15.38,0,0,0,39.23,98c.19-.33,3.4-5.89,1.48-11.87-.38-1.25-1-3.07-2.34-3.4C36.31,82.16,34,85.56,33.87,85.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.07,102.51a43.46,43.46,0,0,1,3.3-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.22,123.14c3.45-3.49,3.26-8.86,3.16-11a20.12,20.12,0,0,0-1-5.6,15.71,15.71,0,0,0-5,3.64c-.24.28-4.5,5.07-3.79,11.34.15,1.3.39,3.21,1.63,3.83C43.11,126.2,46,123.33,46.22,123.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.42,106.53a43.68,43.68,0,0,1-3.06,11.3,42.27,42.27,0,0,1-4.12,7.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.52,6.53c-2.83,4-8.14,4.74-10.29,5a22.65,22.65,0,0,1-5.7,0A15.17,15.17,0,0,1,35.26,6C35.5,5.71,39.52.69,45.79.3c1.29-.09,3.25-.19,4,1C51,2.94,48.71,6.29,48.52,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.53,11.55a44.34,44.34,0,0,0,10.58-5,45.38,45.38,0,0,0,6.7-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.26,48.75c-4.41-2.16-6-7.28-6.61-9.38a20.43,20.43,0,0,1-.91-5.6,16.31,16.31,0,0,1,5.94,1.77C52,35.73,57.61,38.89,59,45c.29,1.3.72,3.16-.29,4.12C57.18,50.66,53.54,48.89,53.26,48.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.74,33.81a44.15,44.15,0,0,0,6.66,9.67,45.19,45.19,0,0,0,6.36,5.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M200.89,145.59a80.44,80.44,0,0,0,21.88-35.42c1.82-6.08,7.95-30.4-3.16-52.52-3.35-6.6-9.91-11-11.2-20.73-.91-6.7.67-12.78,1.48-15.84a53.38,53.38,0,0,1,7.66-16.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M244.84,27.64a41.72,41.72,0,0,1-25.18,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M226,91.69c-3,3.21-13.07,13.36-28.53,14.46a39.1,39.1,0,0,1-13.5-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188.64,14.19a24.34,24.34,0,0,0,3.49,11.48c5.27,8.62,14.31,10.87,16.23,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M236.46,24.33c3.4,3.55,3.16,8.91,3,11.06a20.18,20.18,0,0,1-1.06,5.6,16.57,16.57,0,0,1-5-3.68c-.24-.29-4.45-5.17-3.68-11.4.14-1.29.38-3.2,1.67-3.78C233.4,21.22,236.22,24.14,236.46,24.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M238.47,41a43.17,43.17,0,0,0-7-18.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M244.6,61.29c-1.2-4.79-5.84-7.37-7.76-8.42a23.62,23.62,0,0,0-5.26-2.11,15.7,15.7,0,0,0,.48,6.17c.09.34,2,6.52,7.66,9.2,1.19.57,2.92,1.38,4.06.62C245.6,65.6,244.65,61.63,244.6,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M231.58,50.76A43.93,43.93,0,0,1,243.83,66.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M211.28,85.8c2.68,4.12,1.44,9.34.91,11.44a21.11,21.11,0,0,1-2.06,5.32A15.38,15.38,0,0,1,206,98c-.2-.33-3.4-5.89-1.49-11.87.39-1.25,1-3.07,2.35-3.4C208.84,82.16,211.14,85.56,211.28,85.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M210.08,102.51a43.46,43.46,0,0,0-3.3-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M198.88,123.14c-3.45-3.49-3.25-8.86-3.16-11a20.12,20.12,0,0,1,1-5.6,15.86,15.86,0,0,1,5,3.64c.23.28,4.5,5.07,3.83,11.34-.15,1.3-.39,3.21-1.63,3.83C202,126.2,199.12,123.33,198.88,123.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M196.73,106.53a43.89,43.89,0,0,0,7.18,18.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M196.63,6.53c2.83,4,8.14,4.74,10.29,5a22.65,22.65,0,0,0,5.7,0A15.17,15.17,0,0,0,209.89,6c-.24-.29-4.26-5.31-10.53-5.7-1.29-.09-3.26-.19-4,1C194.09,2.94,196.44,6.29,196.63,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M212.62,11.55a45.07,45.07,0,0,1-10.58-5,42.35,42.35,0,0,1-6.7-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M191.89,48.75c4.41-2.16,6-7.28,6.61-9.38a20.43,20.43,0,0,0,.91-5.6,16.31,16.31,0,0,0-5.94,1.77c-.33.19-5.93,3.35-7.32,9.47-.29,1.3-.72,3.16.28,4.12C187.92,50.66,191.6,48.89,191.89,48.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M199.41,33.81a43.35,43.35,0,0,1-13,15.37"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 122.33,
    cy: 234.43,
    r: 12.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 88.16,
    cy: 249.28,
    r: 3.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 110.13,
    y1: 234.39,
    x2: 50.96,
    y2: 234.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 113.14,
    y1: 226.35,
    x2: 91.22,
    y2: 220.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 113.14,
    y1: 242.48,
    x2: 91.22,
    y2: 248.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 88.16,
    cy: 219.46,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 44.07,
    cy: 234.39,
    r: 7.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 156.99,
    cy: 219.51,
    r: 3.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 135.02,
    y1: 234.35,
    x2: 194.19,
    y2: 234.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 132.01,
    y1: 242.44,
    x2: 153.88,
    y2: 248.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 132.01,
    y1: 226.3,
    x2: 153.88,
    y2: 220.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 156.99,
    cy: 249.33,
    r: 3.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 201.04,
    cy: 234.35,
    r: 7.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 122.34,
    y1: 227.69,
    x2: 122.34,
    y2: 241.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 129.09,
    y1: 234.39,
    x2: 115.63,
    y2: 234.39
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRania);
export default __webpack_public_path__ + "static/media/rania.9ec3c17a9cbf6bf44f36694d026a8fc3.svg";
export { ForwardRef as ReactComponent };